const nameInitials = ({ firstName, lastName }) => {
  const first = firstName?.charAt(0) !== undefined ? firstName?.charAt(0).toUpperCase() : '';
  const last = lastName?.charAt(0) !== undefined ? lastName?.charAt(0).toUpperCase() : '';
  return `${first} ${last}`;
};

export default nameInitials;
